var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$apollo.queries.menu.loading)?_c('ResturantInfo',{ref:"xx"}):_vm._e(),(!_vm.$apollo.queries.menu.loading)?_c('ResturantMenu'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }